module.exports = __webpack_public_path__ + "static/media/TWELVE.69bf41c6.png";